export default __webpack_public_path__ + "static/media/Q16_2_resized.a127080a.jpg";